"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
var _nonRankedFromExisting = _interopRequireDefault(require("./non-ranked-from-existing"));
var _nonRankedFromScratch = _interopRequireDefault(require("./non-ranked-from-scratch"));
var _TsAndCs = _interopRequireDefault(require("./TsAndCs"));
var _confirmPukMembership = _interopRequireDefault(require("./confirm-puk-membership"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// The non-ranked modal process consists of 5 displayed pages:
// 1. Query whether or not ranked in another class
// 2. Selecting an existing paddler to add to new classDivision
// 3. Entering details for a new paddler
// 4. Confirming Membership info for a new paddler if appropriate.
// 5. Welcome and risk statement

// Users creating a bib for a single paddler follow one of three processes
// depending on response to question in 1
// A(already ranked/registered paddler): 1, 2, 5 then add
// B(brand new paddler not a member of paddle uk): 1,3,5 then add
// C(new paddler who is a member of paddle uk): 1,3,4,5 then add

// For paddling pairs - ie C2s the process is more iterative as we go back to 1 (for the second paddler)
// before finishing at 5.

function getInitialState(props) {
  return {
    addingPaddler: false,
    addingFromExisting: false,
    addingFromScratch: false,
    confirmingMembership: false,
    acceptingTCs: false,
    addingSecondPaddler: false,
    validating: false,
    addingToDB: false,
    error: null,
    paddler1: {
      newFromExisting: {
        existingClassRef: null,
        existingClassDivisionID: null,
        existingPaddlerID: null
      },
      newFromScratch: {
        paddlerName: null,
        paddlerClubID: null,
        genderRef: props.classDivision.genderRef,
        isBCMember: null,
        membershipNationRef: null,
        bcNumber: null,
        countryRef: 'GBR',
        yearOfBirth: null,
        validatedPukMembership: {}
      }
    },
    paddler2: {
      newFromExisting: {
        existingClassRef: null,
        existingClassDivisionID: null,
        existingPaddlerID: null
      },
      newFromScratch: {
        paddlerName: null,
        paddlerClubID: null,
        genderRef: props.classDivision.genderRef,
        isBCMember: null,
        membershipNationRef: null,
        bcNumber: null,
        countryRef: 'GBR',
        yearOfBirth: null,
        validatedPukMembership: {}
      }
    }
  };
}
class NonRankedPaddlerModal extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", getInitialState(this.props));
    _defineProperty(this, "_onTogglePage", nextPage => {
      return this.setState({
        [nextPage]: !this.state[nextPage]
      });
    });
    _defineProperty(this, "_onAcknowledgeError", () => {
      this.setState({
        error: false
      });
    });
    _defineProperty(this, "_onFinish", () => {
      this.setState(getInitialState(this.props));
    });
    _defineProperty(this, "_getExistingPaddler", () => {
      const existingPaddler = this.state.addingSecondPaddler ? this.state.paddler2.newFromExisting : this.state.paddler1.newFromExisting;
      return existingPaddler;
    });
    _defineProperty(this, "_onSetExistingValue", (field, value) => {
      const paddler = this.state.addingSecondPaddler ? 'paddler2' : 'paddler1';
      return this.setState({
        [paddler]: {
          ...this.state[paddler],
          newFromExisting: {
            ...this.state[paddler].newFromExisting,
            [field]: value
          }
        }
      });
    });
    _defineProperty(this, "_getScratchPaddler", () => {
      const scratchPaddler = this.state.addingSecondPaddler ? this.state.paddler2.newFromScratch : this.state.paddler1.newFromScratch;
      return scratchPaddler;
    });
    _defineProperty(this, "_onSetScratchValue", (field, value) => {
      const paddler = this.state.addingSecondPaddler ? 'paddler2' : 'paddler1';
      return this.setState({
        [paddler]: {
          ...this.state[paddler],
          newFromScratch: {
            ...this.state[paddler].newFromScratch,
            [field]: value
          }
        }
      });
    });
    _defineProperty(this, "_nextPaddler", () => {
      this.setState({
        addingFromExisting: false,
        addingFromScratch: false,
        confirmingMembership: false,
        addingSecondPaddler: true
      });
    });
    _defineProperty(this, "_oncheckNoExistingBibsForNewPaddler", async e => {
      e.preventDefault();
      this.setState({
        validating: true
      });
      const paddler = this.state.addingSecondPaddler ? 'paddler2' : 'paddler1';
      const scratchPaddler = this._getScratchPaddler();
      const bibsResults = await this.props.checkNoExistingBibsForNewPaddler(this.props.yearID, scratchPaddler);
      if (!bibsResults.ok) return this.setState({
        error: bibsResults.error,
        validating: false
      });
      this.setState({
        validating: false
      });
      return this.props.classDivision.classRef === 'C2' && !this.state.addingSecondPaddler ? this._nextPaddler() : this._onTogglePage('acceptingTCs');
    });
    _defineProperty(this, "_onValidateMembership", async () => {
      this.setState({
        validating: true
      });
      const paddler = this.state.addingSecondPaddler ? 'paddler2' : 'paddler1';
      const scratchPaddler = this._getScratchPaddler();
      if (!scratchPaddler.membershipNationRef || !scratchPaddler.bcNumber) return this.setState({
        error: 'Please enter your Paddle UK membership details',
        validating: false
      });
      const membershipResults = await this.props.validatePukMembership(this.props.yearID, scratchPaddler);
      if (!membershipResults.ok) return this.setState({
        error: membershipResults.error,
        validating: false
      });
      this.setState({
        [paddler]: {
          ...this.state[paddler],
          newFromScratch: {
            ...this.state[paddler].newFromScratch,
            validatedPukMembership: membershipResults.value
          }
        }
      });
      const bibCheckResults = await this.props.checkNoExistingBibsForNewPaddler(this.props.yearID, scratchPaddler);
      if (!bibCheckResults.ok) return this.setState({
        error: bibCheckResults.error,
        validating: false
      });
      this.setState({
        validating: false
      });
      this._onTogglePage('confirmingMembership');
    });
    _defineProperty(this, "_onAddIndividual", async () => {
      if (this.state.addingToDB) return null;
      this.setState({
        addingToDB: true
      });
      const results = await this.props.createUnrankedBib(this.state.paddler1, this.state.paddler2, this.props.yearID, this.props.classDivision.id);
      if (results.error) {
        this.setState({
          error: results.error,
          addingToDB: false
        });
        return this._onTogglePage('acceptingTCs');
      }
      this.props.setBibID(results.cseBibID);
      this.setState(getInitialState(this.props));
    });
    _defineProperty(this, "_onAddPaddlingPair", async e => {
      if (this.state.addingToDB) return null;
      this.setState({
        addingToDB: true
      });
      const results = await this.props.createUnrankedBib(this.state.paddler1, this.state.paddler2, this.props.yearID, this.props.classDivision.id);
      if (results.error)
        // if an error than push user through whole process
        // again, but keep any existing data selected/entered
        // as we don't know where error is
        return this.setState({
          error: results.error,
          addingFromExisting: false,
          addingFromScratch: false,
          confirmingMembership: false,
          acceptingTCs: false,
          addingSecondPaddler: false,
          addingToDB: false
        });
      this.props.setBibID(results.cseBibID);
      this.setState(getInitialState(this.props));
    });
  }
  render() {
    const isPair = this.props.classDivision.classRef === 'C2';

    // isNonPaddler was added to allow us to simplify the process when
    // using the system for taking payment for 2019 Reunion Meal
    const isNonPaddler = this.props.classDivision.classRef === 'NP';
    // isInternational allows international entries for British Open to avoid all the Paddle UK info
    const isInternational = this.props.classDivision.rankingDivisionRef === 'INTL';
    const modalTitle = 'Add New ' + (isNonPaddler ? 'Non-' : '') + (isInternational ? 'International ' : '') + 'Paddler for Online Entry for ' + this.props.classDivision.classDescription;
    const acceptTCsButtons = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onFinish
    }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: () => this._onTogglePage('acceptingTCs')
    }, "Back"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: isPair ? this._onAddPaddlingPair : this._onAddIndividual,
      type: "primary"
    }, this.props.addingToDB ? 'Please Wait ...' : 'Accept'));
    const addFromExistingButtons = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: () => this._onTogglePage('addingFromExisting')
    }, "Back"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: () => isPair && !this.state.addingSecondPaddler ? this._nextPaddler() : this._onTogglePage('acceptingTCs'),
      type: "primary",
      disabled: !this._getExistingPaddler().existingPaddlerID
    }, "Next"));
    const confirmMembershipButtons = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: () => this._onTogglePage('confirmingMembership')
    }, "Back"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: () => isPair && !this.state.addingSecondPaddler ? this._nextPaddler() : this._onTogglePage('acceptingTCs'),
      type: "primary"
    }, "Next"));
    const addFromScratchButtons = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: () => this._onTogglePage('addingFromScratch')
    }, "Back"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._getScratchPaddler().isBCMember === 'yes' ? this._onValidateMembership : this._oncheckNoExistingBibsForNewPaddler,
      type: "primary",
      disabled: !(!this.state.validating && this._getScratchPaddler().paddlerName !== null && this._getScratchPaddler().genderRef && (this._getScratchPaddler().isBCMember === 'no' || isNonPaddler || isInternational && this._getScratchPaddler().countryRef !== 'GBR' || this._getScratchPaddler().isBCMember === 'yes' && this._getScratchPaddler().nationRef !== null && this._getScratchPaddler().bcNumber !== null))
    }, this.state.validating ? 'Please Wait ...' : 'Next'));
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, this.state.error ? /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onAcknowledgeError,
      type: "primary"
    }, "OK") : this.state.acceptingTCs ? acceptTCsButtons : this.state.addingFromExisting ? addFromExistingButtons : this.state.confirmingMembership ? confirmMembershipButtons : this.state.addingFromScratch ? addFromScratchButtons : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: () => this._onTogglePage('addingFromExisting')
    }, "Yes"), ' ', /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: () => this._onTogglePage('addingFromScratch')
    }, "No"), ' ', /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onFinish
    }, "Cancel")));
    return /*#__PURE__*/_react.default.createElement("span", null, !this.state.addingPaddler && !this.state.addingFromScratch ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: modalButtons,
      onClose: this._onFinish,
      title: modalTitle
    }, this.state.error ? /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "danger"
    }, this.state.error) : this.state.acceptingTCs ? /*#__PURE__*/_react.default.createElement(_TsAndCs.default, {
      isPair: isPair,
      paddler1: this.state.paddler1,
      paddler2: this.state.paddler2
    }) : this.state.addingFromExisting ? /*#__PURE__*/_react.default.createElement(_nonRankedFromExisting.default, {
      yearID: this.props.yearID,
      existing: this._getExistingPaddler(),
      setValue: this._onSetExistingValue
    }) : this.state.confirmingMembership ? /*#__PURE__*/_react.default.createElement(_confirmPukMembership.default, {
      scratchPaddler: this._getScratchPaddler(),
      member: this._getScratchPaddler().validatedPukMembership
    }) : this.state.addingFromScratch ? /*#__PURE__*/_react.default.createElement(_nonRankedFromScratch.default, {
      yearID: this.props.yearID,
      scratchPaddler: this._getScratchPaddler(),
      isInternational: isInternational,
      isNonPaddler: isNonPaddler,
      genderDescription: this.props.classDivision.genderDescription,
      setValue: this._onSetScratchValue
    }) : /*#__PURE__*/_react.default.createElement("p", {
      className: "lead"
    }, "Is", !isPair ? ' ' : this.state.addingSecondPaddler ? ' next ' : ' first ', "paddler ranked or registered in another class?")), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: () => this._onTogglePage('addingPaddler'),
      block: true
    }, "Click here to add a Paddler to list."));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(NonRankedPaddlerModal, undefined, (client, props) => ({
  createUnrankedBib(paddler1, paddler2, yearID, classDivisionID) {
    return client.update('CseBib.createUnrankedBib', {
      yearID,
      classDivisionID,
      paddlerID1: paddler1.newFromExisting.existingPaddlerID,
      paddlerName1: paddler1.newFromScratch.paddlerName,
      yearOfBirth1: paddler1.newFromScratch.yearOfBirth,
      paddlerClubID1: paddler1.newFromScratch.paddlerClubID,
      genderRef1: paddler1.newFromScratch.genderRef,
      isBCMember1: paddler1.newFromScratch.isBCMember === 'yes',
      membershipNationRef1: paddler1.newFromScratch.membershipNationRef,
      bcNumber1: paddler1.newFromScratch.bcNumber,
      countryRef1: paddler1.newFromScratch.countryRef,
      paddlerID2: paddler2.newFromExisting.existingPaddlerID,
      paddlerName2: paddler2.newFromScratch.paddlerName,
      yearOfBirth2: paddler2.newFromScratch.yearOfBirth,
      paddlerClubID2: paddler2.newFromScratch.paddlerClubID,
      genderRef2: paddler2.newFromScratch.genderRef,
      isBCMember2: paddler2.newFromScratch.isBCMember === 'yes',
      membershipNationRef2: paddler2.newFromScratch.membershipNationRef,
      bcNumber2: paddler2.newFromScratch.bcNumber,
      countryRef2: paddler1.newFromScratch.countryRef
    });
  },
  checkNoExistingBibsForNewPaddler(yearID, newFromScratch) {
    return client.update('Paddler.checkNoExistingBibsForNewPaddler', {
      yearID,
      paddlerName: newFromScratch.paddlerName,
      membershipNationRef: newFromScratch.membershipNationRef,
      bcNumber: newFromScratch.bcNumber
    });
  },
  validatePukMembership(yearID, newFromScratch) {
    return client.update('Paddler.validatePukMembership', {
      yearID,
      paddlerName: newFromScratch.paddlerName,
      yearOfBirth: newFromScratch.yearOfBirth,
      genderRef: newFromScratch.genderRef,
      membershipNationRef: newFromScratch.membershipNationRef,
      bcNumber: newFromScratch.bcNumber
    });
  }
}));